import React from 'react';
import {bool, func, object, string} from 'prop-types';

import {connect} from 'react-redux';

import EsmsDialog from '../../components/EsmsDialog';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as ServiceManagementActions from '../../actions/serviceManagementActions';
import * as UiActions from '../../actions/uiActions';

import classes from './DeleteAppointmentModal.module.css';

const DeleteAppointmentModal = ({
    activeAppointment,
    activeItem,
    clearErrors,
    close,
    deleteAppointment,
    errors,
    isLoading,
    open,
    title,
    toggleLoading,
    ...props
}) => {
    const getAppointmentNumber = () => {
        return `WO-${activeItem.workOrder}-${activeAppointment.appointmentNum}`;
    };

    const handleDelete = async () => {
        let isDeleted;

        if (!isLoading) {
            toggleLoading(true);
            isDeleted = await deleteAppointment(activeAppointment.id);
        }

        if (isDeleted) handleClose();
    };

    const handleClose = () => {
        clearErrors();
        toggleLoading(false);
        close();
    };

    return (
        <EsmsDialog
            confirmText="Delete"
            errors={errors}
            isLoading={isLoading}
            open={open}
            onClose={handleClose}
            onConfirm={handleDelete}
            title={title}
        >
            <div className={classes.DeleteAppointmentModal}>
                <p>Are you sure you want to delete {getAppointmentNumber()}?</p>
            </div>
        </EsmsDialog>
    );
};

DeleteAppointmentModal.defaultProps = {
    activeAppointment: {},
    activeItem:        {},
    close:             () => {},
    isLoading:         false,
    open:              false,
    title:             ''
};

DeleteAppointmentModal.propTypes = {
    activeAppointment: object,
    activeItem:        object,
    close:             func,
    isLoading:         bool,
    open:              bool,
    title:             string
};

const mapStateToProps = state => {
    return {
        activeAppointment: state.svcManagement.activeAppointment,
        activeItem:        state.svcManagement.activeItem,
        errors:            state.messages.errors,
        isLoading:         state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...ServiceManagementActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAppointmentModal);
